<template>
  <div id="app">
    <div class="app-layout">
      <Sidebar
        v-if="!isLoginPage"
        :collapsed="sidebarCollapsed"
        @toggle-sidebar="toggleSidebar"
      />
      <main :class="['main-content', { 'sidebar-gone': isLoginPage }]">
        <router-view
          :sidebarCollapsed="sidebarCollapsed"
          @toggle-sidebar="toggleSidebar"
        />
      </main>
    </div>
    <Toaster />
  </div>
</template>

<script>
import { Toaster } from "vue-sonner";
import Sidebar from "./components/Sidebar.vue";
import { useRoute } from "vue-router";
export default {
  name: "App",
  components: { Toaster, Sidebar },
  data() {
    return {
      sidebarCollapsed: false,
    };
  },
  computed: {
    isLoginPage() {
      // Works for /login and /login?redirect=...
      return this.$route.path === "/login";
    },
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  min-height: 100vh;
}

/* Auth loading screen */
.auth-loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: var(--background);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #00ff00;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.auth-loading p {
  color: var(--text-secondary);
  font-size: 1rem;
}

/* Access denied banner */
.access-denied-banner {
  background: #fee;
  border-bottom: 1px solid #fcc;
  padding: 1rem;
  position: relative;
  z-index: 999;
}

.banner-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 auto;
  color: #c53030;
  font-weight: 500;
}

.banner-icon {
  font-size: 1.2rem;
}

.dismiss-btn {
  margin-left: auto;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #c53030;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.dismiss-btn:hover {
  opacity: 0.7;
}

.app-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  background-color: var(--background);
  padding: 0;
  margin-left: calc(280px + 2rem); /* Sidebar width + 2rem spacing */
}

.main-content.sidebar-gone {
  margin-left: 0 !important;
}

.sidebar-btn {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
}

/* When sidebar is collapsed */
body.sidebar-collapsed .main-content {
  margin-left: calc(120px + 2rem); /* Collapsed sidebar width + 2rem spacing */
}

/* Mobile responsive */
@media (max-width: 768px) {
  .main-content {
    margin-left: 0; /* No margin on mobile - sidebar overlays */
  }

  body.sidebar-collapsed .main-content {
    margin-left: 0; /* No margin on mobile when collapsed */
  }
}

body {
  font-family: "Pptelegraf-Light", sans-serif;
  line-height: 1.5;
  color: var(--text-primary);
  background-color: var(--background);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
